import React, { ChangeEvent, MouseEvent } from 'react'
import { LabelPlacement, LabelWidth, RadioButtonSizes, RadioIcon, RadioKind } from './types'

interface RadioGroupContextProps {
  value?: string
  name?: string
  disabled?: boolean
  size?: RadioButtonSizes
  indent?: boolean
  kind?: RadioKind
  icon?: RadioIcon
  reversed?: boolean
  labelWidth?: LabelWidth
  labelPlacement?: LabelPlacement
  testNameSpace?: string
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void
  onClick?: (e: MouseEvent<HTMLInputElement>) => void
}

export const RadioGroupContext = React.createContext<RadioGroupContextProps>({})
